<span class="hourglass-wrapper">
  <mat-icon class="hourglass-top">hourglass_top</mat-icon>
  <mat-icon class="hourglass-bottom">hourglass_bottom</mat-icon>
</span>
